export const REQUEST_SYSTEM_LOGS = 'REQUEST_SYSTEM_LOGS';
export const REQUEST_SYSTEM_LOGS_SUCCESS = 'REQUEST_SYSTEM_LOGS_SUCCESS';
export const REQUEST_SYSTEM_LOGS_FAILURE = 'REQUEST_SYSTEM_LOGS_FAILURE';

export const REQUEST_SYSTEM_LOGS_PRINT = 'REQUEST_SYSTEM_LOGS_PRINT';
export const REQUEST_SYSTEM_LOGS_PRINT_SUCCESS = 'REQUEST_SYSTEM_LOGS_PRINT_SUCCESS';
export const REQUEST_SYSTEM_LOGS_PRINT_FAILURE = 'REQUEST_SYSTEM_LOGS_PRINT_FAILURE';

export const REQUEST_SYSTEM_LOG = 'REQUEST_SYSTEM_LOG';
export const REQUEST_SYSTEM_LOG_SUCCESS = 'REQUEST_SYSTEM_LOG_SUCCESS';
export const REQUEST_SYSTEM_LOG_FAILURE = 'REQUEST_SYSTEM_LOG_FAILURE';